/* Publish by EComposer at 2024-07-29 02:27:12*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pgz74jm1ph"]=  window.__ectimmers["ecom-pgz74jm1ph"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-pgz74jm1ph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pgz74jm1ph', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oc6sn7rs9e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oc6sn7rs9e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7hy1la79gqw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7hy1la79gqw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-st6q2mecp8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-st6q2mecp8h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rfoxrl850cd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rfoxrl850cd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oxiz6xccm9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oxiz6xccm9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o2qpngc3meq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o2qpngc3meq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2bbekts1cdg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2bbekts1cdg', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hn70ek5fnt9"]=  window.__ectimmers["ecom-hn70ek5fnt9"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-hn70ek5fnt9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hn70ek5fnt9', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j8x1jozvy3i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j8x1jozvy3i', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6esxe850nw5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6esxe850nw5', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8pvzm349zuw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8pvzm349zuw', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fl6erwwxv3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fl6erwwxv3', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kxwt9841fns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kxwt9841fns', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l43xbdm1vb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l43xbdm1vb', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bsbh0aw7eu5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bsbh0aw7eu5', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i2za1zonsi9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i2za1zonsi9', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ahffmeageml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahffmeageml', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}